var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mdb-container',[_c('mdb-row',[(_vm.showSpinner)?_c('mdb-col',[_c('Spinner')],1):_vm._e()],1),_c('mdb-row',[_c('StationForm',{attrs:{"station":_vm.stationInfo},on:{"station-updated":_vm.onStationUpdated}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }